(() => {
  const storageKey = 'remain-silent-recent-products-v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,200}$/.test(value);
  function readHistory(storage) {
    try {
      const values = JSON.parse(storage.getItem(storageKey) || '[]');
      return Array.isArray(values) ? [...new Set(values.filter(validHandle))].slice(0, 12) : [];
    } catch { return []; }
  }
  function nextHistory(previous, current) {
    return validHandle(current) ? [current, ...previous.filter(handle => handle !== current)].slice(0, 12) : previous;
  }
  function galleryPagination() {
    const gallery = document.querySelector('product-info media-gallery');
    if (!gallery || gallery.querySelector('.rs-gallery-pagination')) return;
    const list = gallery.querySelector('[id^="Slider-Gallery-"]');
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!list || !viewer) return;
    const slides = Array.from(list.children).filter(slide => !slide.classList.contains('product__media-item--variant'));
    if (slides.length < 2) return;
    const pagination = document.createElement('div');
    pagination.className = 'rs-gallery-pagination';
    const buttons = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', (gallery.getAttribute('aria-label') || 'Product media') + ' ' + (index + 1));
      button.setAttribute('aria-current', String(index === 0));
      button.addEventListener('click', () => {
        list.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      pagination.append(button);
      return button;
    });
    viewer.append(pagination);
    list.addEventListener('scroll', () => {
      const origin = slides[0].offsetLeft;
      const active = slides.reduce((nearest, slide, index) => Math.abs(slide.offsetLeft - origin - list.scrollLeft) < Math.abs(slides[nearest].offsetLeft - origin - list.scrollLeft) ? index : nearest, 0);
      buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
    }, { passive: true });
  }
  async function loadRecentlyViewed(root) {
    const current = root.dataset.currentHandle;
    let storage;
    try { storage = window.localStorage; } catch { return; }
    const previous = readHistory(storage);
    const handles = previous.filter(handle => handle !== current).slice(0, 6);
    try { storage.setItem(storageKey, JSON.stringify(nextHistory(previous, current))); } catch {}
    if (!handles.length) return;
    const base = root.dataset.rootUrl.replace(/\/$/, '');
    const results = await Promise.allSettled(handles.map(async handle => {
      const response = await fetch(base + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      if (!validHandle(product.handle) || product.handle === current) throw new Error('Invalid product');
      return product;
    }));
    if (!root.isConnected) return;
    const cards = root.querySelector('[data-rs-recent-cards]');
    let count = 0;
    let formatter;
    try { formatter = new Intl.NumberFormat(root.dataset.locale || 'en', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: root.dataset.currency || 'EUR' }); }
    catch { formatter = new Intl.NumberFormat('en', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: 'EUR' }); }
    for (const result of results) {
      if (result.status !== 'fulfilled') continue;
      const product = result.value;
      const card = document.createElement('a');
      card.className = 'rs-product-card';
      card.href = base + '/products/' + encodeURIComponent(product.handle);
      const photo = document.createElement('div');
      photo.className = 'rs-product-card-photo';
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.width = 750;
        image.height = 900;
        photo.append(image);
      }
      const title = document.createElement('span');
      title.className = 'rs-product-card-title';
      title.textContent = product.title;
      const price = document.createElement('span');
      price.className = 'rs-product-card-price';
      price.textContent = formatter.format(product.price / 100);
      card.append(photo, title, price);
      cards.append(card);
      count++;
    }
    if (count) root.querySelector('[data-rs-recently-viewed]').hidden = false;
  }
  async function loadComplementary(root) {
    const combine = root.querySelector('[data-rs-combine]');
    if (!combine?.dataset.recommendationsUrl) return;
    try {
      const response = await fetch(combine.dataset.recommendationsUrl, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-rs-combine]');
      if (fresh && !fresh.hidden && fresh.querySelector('.rs-product-card') && root.isConnected) {
        combine.replaceChildren(...fresh.childNodes);
        combine.hidden = false;
      }
    } catch {}
  }
  function initialize() {
    galleryPagination();
    document.querySelectorAll('[data-rs-product-extras]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      loadRecentlyViewed(root);
      loadComplementary(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  if (typeof module !== 'undefined' && module.exports) module.exports = { readHistory, nextHistory, validHandle, storageKey };
})();

(function(){
  const root=document.querySelector('product-info[id^="MainProduct-"]');
  if(!root)return;
  function labelSizeCharts(){
    root.querySelectorAll('.ks-chart-modal-link').forEach(link=>{
      link.setAttribute('aria-label','Size chart');
      let label=link.querySelector('._ks_text');
      if(!label){label=document.createElement('span');label.className='_ks_text';link.appendChild(label);}
      if(label.textContent!=='SIZE CHART')label.textContent='SIZE CHART';
      if(!link.querySelector('.rs-size-chart-icon')){
        const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');
        icon.setAttribute('class','rs-size-chart-icon');
        icon.setAttribute('viewBox','0 0 24 24');
        icon.setAttribute('aria-hidden','true');
        icon.innerHTML='<rect x="2" y="7" width="20" height="10" rx="1"/><path d="M6 7v5m4-5v3m4-3v5m4-5v3"/>';
        link.prepend(icon);
      }
      if(link.dataset.rsSizeChart)return;
      link.dataset.rsSizeChart='true';
      if(!link.matches('a[href],button')){
        link.setAttribute('role','button');link.setAttribute('tabindex','0');
        link.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();link.click();}});
      }
    });
  }
  labelSizeCharts();
  new MutationObserver(labelSizeCharts).observe(root,{childList:true,subtree:true});
})();
